/**
 * 拓扑插件-全局公共mixins函数
 */


export default {
  methods: {
    /**
     * 根据src源路径获取一个image对象，可以是图片、css或js
     * @param src 资源地址
     * @returns {*} image 对象
     */
    getImage(src) {
      const image = new Image();
      image.src = src;
      return image;
    },
    /**
     * 获取画布舞台对象
     */
    getCanvasStage() {
      return this.tpStore.canvasStage;
    },
    /**
     * 获取拓扑ID
     */
    getTpId() {
      return this.tpStore.tpId;
    },
    /**
     * 获取画布后台图层数组
     */
    getLayerArray() {
      return this.tpStore.canvasLayerArray;
    }
  }
};
